import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShippingService } from '../../services/api-services/shipping.service';
import { HelperService } from '../../services/helper.service';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { KRollService } from '../../services/api-services/kroll.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent {
  patientInfo: any = {};
  summary: any = {};
  constructor(public dialogRef: MatDialogRef<InvoiceComponent>,
    public helperService: HelperService,
    public shippingService: ShippingService,
    public krollService: KRollService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
    this.getSummary(this.props.item)
  }

  getInvoice() {
    let payload = {
      OrderID: this.props.item.OrderID,
      UserID: this.props.item.UserID
    }
    this.shippingService.invoice(payload).subscribe(res => {
      if (res['body']['success']) {
        this.patientInfo = res['body']['data'];
      }
    }, err => {
    })
  }
  public downloadAsPDF() {
    let data = <HTMLElement>document.getElementById('invoice');
    data.classList.add('pdfClass');
    html2canvas(data).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png');

      let imgWidth = 208;
      let pageHeight = 295;
      let imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let pdf = new jsPDF('p', 'mm', 'a4'); // Generates PDF in portrait mode
      let position = 0;

      pdf.addImage(contentDataURL, "PNG", 0, position, imgWidth, imgHeight);

      heightLeft -= pageHeight;
      while (heightLeft >= 2) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save('Invoice.pdf');
      data.classList.remove('pdfClass');
    });
  }

  getSummary(item: any) {
    let payload: any = {};
    payload.OrderID = item.OrderID;
    payload.UserID = item.UserID;
    this.krollService.downloadPdf(payload).subscribe((res: any) => {
      if (res.body.success) {
        this.summary = res.body.data[0];
        let count = Object.keys(this.summary.Insurances).length
        if (this.summary?.Insurances) {
          this.summary.Insurances['sum'] = [];
          Object.keys(this.summary.Insurances).forEach((res: any, index: any) => {
            if (index != count) {
              let value: any = {};
              value.name = res
              value.value = this.summary.Insurances[res].reduce((accum: any, amt: any) => Number(accum) + Number(amt), 0)
              this.summary.Insurances.sum.push(value)
            }
          });
        }

        let counts = Object.keys(this.summary.Taxes).length
        if (this.summary?.Taxes) {
          this.summary.Taxes['sum'] = [];
          Object.keys(this.summary.Taxes).forEach((res: any, index: any) => {
            if (index != counts) {
              let value: any = {};
              value.name = res
              value.value = this.summary.Taxes[`${res}`]
              this.summary.Taxes.sum.push(value)
            }
          });
        }
      }
    })
  }
}
